export default {
  "member": "Socio",
  "staff": "Personal",
  "external": "Externo",
  "unableToLoadBoardMembers": "No se han podido cargar los miembros de la junta",
  "pleaseTryAgainShortly": "Vuelva a intentarlo en unos instantes.",
  "pleaseUploadAnImageFile": "Suba un archivo de imagen.",
  "imageMustBe5MBOrSmaller": "La imagen debe tener un tamaño máximo de 5 MB.",
  "nameIsRequired": "El nombre es obligatorio.",
  "pleaseSelectAMemberFromSearch": "Seleccione un socio de los resultados de búsqueda.",
  "pleaseSelectAStaffRecordFromSearch": "Seleccione una persona del directorio de personal.",
  "enterAValidEmailAddress": "Introduzca una dirección de correo electrónico válida.",
  "boardMemberAdded": "Miembro de la junta añadido",
  "theRosterHasBeenUpdatedSuccessfully": "La lista se ha actualizado correctamente.",
  "unableToAddBoardMember": "No se ha podido añadir al miembro de la junta",
  "pleaseReviewTheDetailsAndTryAgain": "Revise los datos y vuelva a intentarlo.",
  "unableToUpdateStatus": "No se ha podido actualizar el estado",
  "pleaseTryAgain": "Vuelva a intentarlo.",
  "roleTitleIsTooLong": "El título del cargo es demasiado largo",
  "roleTitleMustBe80CharactersOrFewer": "El título del cargo no puede superar los 80 caracteres.",
  "roleUpdated": "Cargo actualizado",
  "boardMemberRoleHasBeenUpdated": "Se ha actualizado el cargo del miembro de la junta.",
  "unableToUpdateRole": "No se ha podido actualizar el cargo",
  "boardMemberRemoved": "Miembro de la junta retirado",
  "theBoardRosterHasBeenUpdated": "Se ha actualizado la lista de la junta.",
  "unableToRemoveBoardMember": "No se ha podido retirar al miembro de la junta",
  "roster": "Lista de miembros",
  "boardMembers": "Miembros de la junta",
  "manageTheDirectorsOfficersAndExternalAdvisorsWhoShapeGovernanceDecisions": "Gestione a los directivos, responsables y asesores externos que participan en las decisiones de gobierno.",
  "addBoardMember": "Añadir miembro de la junta",
  "buildYourGovernanceRoster": "Configure la lista de gobierno",
  "addBoardDirectorsStaffLiaisonsOrExternalAdvisorsToPrepareForSecureVoting": "Añada directivos, representantes del personal o asesores externos para preparar votaciones seguras.",
  "trackMemberTypeRoleTitlesAndAccessStatusInOnePremiumRoster": "Consulte el tipo de miembro, su cargo y su estado de acceso en una única lista.",
  "activeRoster": "Lista activa",
  "keepTheBoardRosterCurrentForSecureGovernanceAndFutureVotingWorkflows": "Mantenga actualizada la lista de la junta para una gestión segura y futuras votaciones.",
  "role": "Cargo",
  "type": "Tipo",
  "contact": "Contacto",
  "status": "Estado",
  "actions": "Acciones",
  "boardMember": "Miembro de la junta",
  "active": "Activo",
  "inactive": "Inactivo",
  "boardMemberActions": "Acciones del miembro de la junta",
  "editRole": "Editar cargo",
  "delete": "Eliminar",
  "memberType": "Tipo de miembro",
  "selectType": "Seleccione un tipo",
  "selectFromTheMemberDirectory": "Seleccione una persona del directorio de socios.",
  "selectFromTheStaffDirectory": "Seleccione una persona del directorio de personal.",
  "enterManuallyAndOptionallyUploadAnAvatar": "Introduzca los datos manualmente y, si lo desea, suba una imagen de perfil.",
  "roleTitle": "Título del cargo",
  "chairTreasurer": "Presidencia, Tesorería",
  "name": "Nombre",
  "searchStaffNameOrEmail": "Buscar personal por nombre o correo",
  "searchMemberNameOr": "Buscar socio por nombre o número",
  "clearSelection": "Borrar selección",
  "type2CharactersToSearch": "Escriba al menos 2 caracteres para buscar",
  "loading": "Cargando...",
  "noResults": "Sin resultados",
  "janeCarter": "Jane Carter",
  "email": "Correo electrónico",
  "optionalDirectorySelectionCanPrefillThis": "Opcional. Puede rellenarse al seleccionar una persona del directorio.",
  "avatarImage": "Imagen de perfil",
  "avatarPreview": "Vista previa de la imagen de perfil",
  "uploadJPGPNGGIFOrWebPUpTo5MB": "Suba un archivo JPG, PNG, GIF o WebP de hasta 5 MB.",
  "clearUploadedOverride": "Quitar la imagen subida",
  "boardMemberRecordsAreScopedToThisClubTenant": "Los registros de miembros de la junta pertenecen exclusivamente a este club.",
  "cancel": "Cancelar",
  "saving": "Guardando...",
  "addMember": "Añadir miembro",
  "memberAvatar": "Imagen del miembro",
  "avatarUnavailable": "Imagen de perfil no disponible",
  "close": "Cerrar",
  "upTo80CharactersLeaveEmptyToClear": "Hasta 80 caracteres. Déjelo vacío para borrar el cargo.",
  "save": "Guardar",
  "removeBoardMember": "¿Retirar al miembro de la junta?",
  "thisCanBeUndoneByAnAdmin": "Un administrador puede deshacer esta acción.",
  "removing": "Retirando...",
  "remove": "Retirar",
  "revenue": "Ingresos",
  "expenses": "Gastos",
  "yTDRevenue": "Ingresos acumulados del año",
  "memberEngagement": "Participación de los socios",
  "activeMembersThisMonth": "Socios activos este mes",
  "openSafetyIncidents": "Incidentes de seguridad abiertos",
  "requiresBoardReview": "Requiere revisión de la junta",
  "financialOverview": "Resumen financiero",
  "revenueBreakdown": "Desglose de ingresos",
  "noRevenueDataYet": "Todavía no hay datos de ingresos",
  "monthlyRevenueTrend": "Evolución mensual de ingresos",
  "noMonthlyRevenueDataYet": "Todavía no hay datos mensuales de ingresos",
  "topExpenseCategories": "Principales categorías de gastos",
  "noExpenseDataYet": "Todavía no hay datos de gastos",
  "nA": "No disponible",
  "noDecisionsRequiringAction": "No hay decisiones que requieran intervención",
  "whenNewMotionsAreSubmittedTheyWillAppearHere": "Las nuevas mociones presentadas aparecerán aquí.",
  "noPriorComparisonAvailable": "No hay una comparación anterior disponible",
  "decisionSpotlight": "Decisión destacada",
  "budgetApproval": "Aprobación del presupuesto",
  "totalBudget": "Presupuesto total",
  "monthlyAverage": "Promedio mensual",
  "varianceVsPrior": "Variación respecto al anterior",
  "error": "Error",
  "validationError": "Error de validación",
  "pleaseSelectAFileAndEnterACategory": "Seleccione un archivo e introduzca una categoría.",
  "success": "Operación completada",
  "documentUploadedSuccessfully": "Documento subido correctamente.",
  "areYouSureYouWantToDeleteThisDocument": "¿Seguro que desea eliminar este documento?",
  "documentDeletedSuccessfully": "Documento eliminado correctamente.",
  "documentsAndPolicies": "Documentos y políticas",
  "searchDocuments": "Buscar documentos...",
  "documentCategory": "Categoría del documento",
  "chooseFile": "Seleccionar archivo",
  "uploading": "Subiendo...",
  "uploadDocument": "Subir documento",
  "category": "Categoría",
  "version": "Versión",
  "lastUpdated": "Última actualización",
  "loadingDocuments": "Cargando documentos...",
  "download": "Descargar",
  "noDocumentsFound": "No se han encontrado documentos.",
  "failedToLoadDocuments": "No se han podido cargar los documentos.",
  "failedToUploadDocument": "No se ha podido subir el documento.",
  "failedToDeleteDocument": "No se ha podido eliminar el documento.",
  "meetings": "Reuniones",
  "createMeeting": "Crear reunión",
  "upcomingMeetings": "Próximas reuniones",
  "pleaseSelectAClubToViewMeetings": "Seleccione un club para ver las reuniones.",
  "attendees": "asistentes",
  "viewDetails": "Ver detalles",
  "noUpcomingMeetingsScheduled": "No hay próximas reuniones programadas.",
  "pastMeetings": "Reuniones anteriores",
  "pleaseSelectAClubToViewPastMeetings": "Seleccione un club para ver las reuniones anteriores.",
  "viewMinutes": "Ver acta",
  "noPastMeetingsFound": "No se han encontrado reuniones anteriores.",
  "notYetOpenForVoting": "La votación todavía no está abierta",
  "pendingForOpenVoting": "Pendiente de apertura de votación",
  "votingInProgress": "Votación en curso",
  "votingCompleted": "Votación finalizada",
  "submissionWithdrawn": "Presentación retirada",
  "boardDecision": "Decisión de la junta",
  "created": "Creada",
  "createdBy": "Creada por",
  "boardSecretariat": "Secretaría de la junta",
  "yes": "Sí",
  "no": "No",
  "abstain": "Abstención",
  "youVoted": "Su voto",
  "outcome": "Resultado:",
  "review": "Revisar",
  "openVoting": "Abrir votación",
  "pendingForOpen": "Pendiente de apertura",
  "thisMotionIsQueuedForVotingOnceLeadershipOpensTheBallotWindow": "Esta moción está pendiente de que los responsables abran el plazo de votación.",
  "closes": "Cierra",
  "boardPackSummary": "Resumen de documentación de la junta",
  "allocationByDepartment": "Asignación por departamento",
  "noAllocationDataAvailable": "No hay datos de asignación disponibles.",
  "whatChangedVsLastYear": "¿Qué ha cambiado respecto al año pasado?",
  "noPriorVersionFound": "No se ha encontrado una versión anterior.",
  "overallVariance": "Variación total",
  "topIncreases": "Principales aumentos",
  "noIncreasesToHighlight": "No hay aumentos que destacar.",
  "topDecreases": "Principales disminuciones",
  "noDecreasesToHighlight": "No hay disminuciones que destacar.",
  "votingManagement": "Gestión de votaciones",
  "openAndCloseVotingWindowsForBoardMembers": "Abra y cierre los plazos de votación para los miembros de la junta.",
  "resendInvites": "Reenviar invitaciones",
  "closeVoting": "Cerrar votación",
  "governanceRecord": "Registro de gobierno",
  "unableToLoadMotionReviewData": "No se han podido cargar los datos de revisión de la moción.",
  "votingOpened": "Votación abierta",
  "boardVotingIsNowLive": "La votación de la junta ya está abierta.",
  "unableToOpenVoting": "No se ha podido abrir la votación",
  "inviteSent": "Invitación enviada",
  "inviteRefreshed": "Invitación actualizada",
  "votingLinkAndOTPResent": "Se han reenviado el enlace de votación y el código de un solo uso.",
  "inviteTokenRefreshedForThisVoter": "Se ha actualizado el código de invitación de este votante.",
  "inviteNotRequired": "No se necesita invitación",
  "thisMemberVotesInTheMembersPortal": "Este miembro vota en el portal de socios.",
  "missingEmail": "Falta el correo electrónico",
  "noEmailIsAvailableForThisBoardMember": "Este miembro de la junta no tiene correo electrónico registrado.",
  "unableToResendInvite": "No se ha podido reenviar la invitación",
  "votingClosed": "Votación cerrada",
  "theResolutionHasBeenFinalized": "La resolución se ha finalizado.",
  "unableToCloseVoting": "No se ha podido cerrar la votación",
  "backToVoting": "Volver a votaciones",
  "motionNotFound": "No se ha encontrado la moción.",
  "motionCreated": "Moción creada",
  "motionOpened": "Moción abierta",
  "voteRecorded": "Voto registrado",
  "motionClosed": "Moción cerrada",
  "motionApproved": "Moción aprobada",
  "motionRejected": "Moción rechazada",
  "motionWithdrawn": "Moción retirada",
  "budgetLocked": "Presupuesto bloqueado",
  "budgetUnlocked": "Presupuesto desbloqueado",
  "budgetCreated": "Presupuesto creado",
  "noGovernanceEventsRecordedYet": "Todavía no hay eventos de gobierno registrados.",
  "board": "Junta",
  "vote": "Voto:",
  "votingWindow": "Plazo de votación",
  "unit": "Unidad",
  "hours": "horas",
  "days": "días",
  "weeks": "semanas",
  "months": "meses",
  "setHowLongBoardVotingRemainsOpen": "Establezca cuánto tiempo permanecerá abierta la votación de la junta.",
  "boardMembersWithMembersPortalAccess": "Miembros de la junta con acceso al portal de socios",
  "theseMembersWillVoteInsideTheMembersPortalVotingTab": "Estos miembros votarán en la pestaña de votaciones del portal de socios.",
  "loadingRoster": "Cargando lista…",
  "unableToLoadRoster": "No se ha podido cargar la lista.",
  "noPortalEnabledBoardMembersFound": "No se han encontrado miembros de la junta con acceso al portal.",
  "boardMembersWithoutMembersPortalAccess": "Miembros de la junta sin acceso al portal de socios",
  "theseMembersWillReceiveATemporaryVotingLinkAndOneTimeCodeViaEmail": "Estos miembros recibirán por correo un enlace temporal de votación y un código de un solo uso.",
  "noEmailOnFile": "Sin correo electrónico registrado",
  "everyoneHasPortalAccess": "Todos tienen acceso al portal.",
  "resendVotingInvites": "Reenviar invitaciones de votación",
  "confirm": "Confirmar",
  "votingPanel": "Panel de votación",
  "pendingForOpenVotingOpenThisMotionToBeginBoardVoting": "Pendiente de apertura de votación. Abra esta moción para iniciar la votación de la junta.",
  "castYourVoteYourSelectionIsRecordedInstantly": "Emita su voto. Su selección se registra al instante.",
  "voteYes": "Votar a favor",
  "voteNo": "Votar en contra",
  "resolution": "Resolución",
  "approved": "Aprobada",
  "membersPortal": "Portal de socios",
  "emailLinkOTP": "Enlace por correo + código de un solo uso",
  "voters": "Votantes",
  "loadingVoters": "Cargando votantes…",
  "method": "Método",
  "lastSent": "Último envío",
  "notVoted": "Sin votar",
  "resendVotingLinkOTP": "Reenviar enlace y código de votación",
  "noVotersFound": "No se han encontrado votantes.",
  "unableToLoadMotions": "No se han podido cargar las mociones",
  "pleaseTryAgainInAFewMoments": "Vuelva a intentarlo en unos instantes.",
  "openForVoting": "Abiertas para votar",
  "closedResolution": "Resolución cerrada",
  "withdrawnMotion": "Moción retirada",
  "viewResolution": "Ver resolución",
  "reviewMotion": "Revisar moción",
  "votingAndResolutions": "Votaciones y resoluciones",
  "reviewBudgetMotionsOpenVotingAndRecordBoardDecisions": "Revise las mociones presupuestarias, abra votaciones y registre las decisiones de la junta.",
  "queuedForGMSecretaryRelease": "Pendiente de apertura por gerencia o secretaría",
  "activeBoardDecisions": "Decisiones activas de la junta",
  "loadingOpenMotions": "Cargando mociones abiertas…",
  "noMotionsAreCurrentlyOpenForVoting": "No hay mociones abiertas para votar.",
  "closedMotions": "Mociones cerradas",
  "finalizedResolutions": "Resoluciones finalizadas",
  "loadingClosedMotions": "Cargando mociones cerradas…",
  "noClosedMotionsYet": "Todavía no hay mociones cerradas.",
  "refreshMotions": "Actualizar mociones",
  "draft": "Borrador",
  "open": "Abierta",
  "closed": "Cerrada",
  "withdrawn": "Retirada",
  "rejected": "Rechazada",
  "viewAvatar": "Ver imagen de perfil de {name}",
  "memberStatus": "Estado activo de {name}",
  "votedChoice": "Voto: {choice}",
  "closesRelative": "Cierra {time}",
  "selectedWindow": "el plazo seleccionado",
  "openedWindow": "Votación abierta; se cierra en {window}.",
  "motionCountOne": "{count} moción en total",
  "motionCountMany": "{count} mociones en total",
  "yoy": "{percent} respecto al año pasado",
  "other": "Otros",
  "uncategorized": "Sin categoría",
  "unavailable": "Datos financieros no disponibles. Vuelva a intentarlo más tarde.",
  "meetingLoadFailed": "No se han podido cargar las reuniones. Vuelva a intentarlo.",
  "emailSubject": "Vote ahora: {title}",
  "emailHeading": "La votación de la junta está abierta",
  "emailMotion": "Moción:",
  "emailCloses": "Cierra:",
  "emailHelp": "Utilice el enlace siguiente para emitir su voto. Se le pedirá el código de un solo uso.",
  "emailCode": "Código de un solo uso:",
  "emailDeadline": "el plazo de votación",
  "missing_email": "Falta el correo electrónico",
  "no_member_match": "Sin registro de socio vinculado",
  "portal_access_disabled": "Acceso al portal desactivado",
  "missing_auth0_id": "Cuenta del portal no disponible",
  "loadingOpenVotes": "Cargando votaciones abiertas…",
  "unableToLoadVotingMotions": "No se han podido cargar las mociones de votación.",
  "boardVoting": "Votación de la junta",
  "openMotions": "Mociones abiertas",
  "reviewCurrentMotionsAndCastYourVoteBeforeTheDeadline": "Revise las mociones actuales y emita su voto antes de que finalice el plazo.",
  "noOpenMotionsRightNow": "No hay mociones abiertas en este momento.",
  "votes": "votos ·",
  "notYetVoted": "Todavía no ha votado",
  "reviewAndVote": "Revisar y votar",
  "loadingMotion": "Cargando moción…",
  "unableToLoadMotionDetails": "No se han podido cargar los detalles de la moción.",
  "motionReview": "Revisión de la moción",
  "opens": "Abre",
  "yourVoteNotRecordedYet": "Su voto todavía no se ha registrado",
  "motionTotals": "Totales de la moción",
  "votesSoFar": "Votos hasta ahora",
  "governanceTimeline": "Cronología de gobierno",
  "timelineUpdatesWillAppearHere": "Las actualizaciones de la cronología aparecerán aquí.",
  "castYourVote": "Emita su voto",
  "unableToRecordVotePleaseTryAgain": "No se ha podido registrar el voto. Vuelva a intentarlo.",
  "boardVotingAccess": "Acceso a la votación de la junta",
  "verifyYourVotingAccess": "Verifique su acceso a la votación",
  "thisVotingLinkIsMissingItsAccessToken": "Este enlace de votación no contiene el código de acceso.",
  "enterYourOneTimeCode": "Introduzca su código de un solo uso",
  "useTheCodeFromYourEmailToUnlockTheBallot": "Utilice el código del correo electrónico para acceder a la votación.",
  "6DigitCode": "Código de 6 dígitos",
  "verifying": "Verificando…",
  "verify": "Verificar",
  "unableToVerifyTheCodePleaseTryAgain": "No se ha podido verificar el código. Vuelva a intentarlo.",
  "motionDetails": "Detalles de la moción",
  "votesRecorded": "Votos registrados:",
  "motionSubmitted": "Moción presentada",
  "attendeeCountOne": "{count} asistente",
  "attendeeCountMany": "{count} asistentes"
}
